import { WORD_LENGTH, type GuessPattern } from "@mk/shared";

const TILE_STAGGER_MS = 180;
const TILE_FLIP_MS = 520;
const TILE_CHEER_DELAY_MS = 560;
const TILE_CHEER_MS = 480;

/**
 * Son tahminden sonra görünüm değiştirmeden önce tahtaya tanınan süre.
 *
 * Normal satır son kutucuğun çevrilmesiyle, doğru satır ise son kutucuğun
 * zafer zıplamasıyla tamamlanır. Böylece sonuç paneli veya rakip tahtası,
 * oyuncu kendi son tahmininin sonucunu görmeden ekranı kapatmaz.
 */
export function duelRevealDuration(pattern: GuessPattern, reducedMotion = false): number {
  if (reducedMotion) return 0;
  const lastTileDelay = (WORD_LENGTH - 1) * TILE_STAGGER_MS;
  const solved = pattern.every((state) => state === "correct");
  return lastTileDelay + (solved ? TILE_CHEER_DELAY_MS + TILE_CHEER_MS : TILE_FLIP_MS);
}

export function prefersReducedMotion(): boolean {
  return typeof window !== "undefined" &&
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
